export type IdeaShow = 'all' | 'searched' | 'trending' | 'anniversaries' | 'news' | 'unwritten'

export const SHOW_FILTERS: { key: IdeaShow; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'searched', label: 'Searched often' },
  { key: 'trending', label: 'Trending now' },
  { key: 'anniversaries', label: 'Anniversaries' },
  { key: 'news', label: 'In the news' },
  { key: 'unwritten', label: 'Not yet written' },
]

export const POLL_MS = 30_000
export const POLL_LIMIT_MS = 5 * 60_000

export const IDEAS_UNAVAILABLE = 'Ideas are unavailable right now. Try Refresh in a few minutes.'
export const IDEAS_EMPTY = 'No ideas yet. Press Refresh to gather them.'

export function parseShow(raw: string | null): IdeaShow {
  return SHOW_FILTERS.some((f) => f.key === raw) ? (raw as IdeaShow) : 'all'
}

/** Each filter's label with its count ("All 24"); no count until one is known. */
export function filterCounts(counts: Partial<Record<IdeaShow, number>> | null | undefined): { key: IdeaShow; label: string; text: string }[] {
  return SHOW_FILTERS.map((f) => {
    const n = counts?.[f.key]
    return { ...f, text: typeof n === 'number' ? `${f.label} ${n}` : f.label }
  })
}

export const SETTLE_NOTE = 'New pages take 4–8 weeks to settle in Google; judge this at 2–3 months.'

/** The card came, at least in part, from what people search for. */
export function hasSearchDemand(idea: { reasons: { key: string }[] }): boolean {
  return idea.reasons.some((r) => r.key === 'search_demand')
}

export function resultsHeadline(r: { window_days: number; search: { published: number; clicks: number } }): string {
  const { published, clicks } = r.search
  if (!published) return 'From search ideas: nothing published yet'
  return `From search ideas: ${published} published · ${clicks} Google ${clicks === 1 ? 'click' : 'clicks'} (last ${r.window_days} days)`
}

/** The results panel shows while the switch is on, and stays once anything was published from search ideas. */
export function showResultsPanel(switchOn: boolean, r: { search: { published: number } } | undefined): boolean {
  return !!r && (switchOn || r.search.published > 0)
}

export { startLink } from './links'

export type RefreshState = 'idle' | 'gathering' | 'already_running' | 'gave_up'

export function refreshMessage(state: RefreshState): string | null {
  switch (state) {
    case 'gathering': return 'Gathering signals — this takes a couple of minutes.'
    case 'already_running': return "Already gathering — ideas update here when it's done."
    case 'gave_up': return 'Still gathering. Check back in a few minutes.'
    default: return null
  }
}

/** Keep polling while a refresh is pending, the time is not up and the stamp has not moved. */
export function shouldPoll(baseline: string | null, current: string | null | undefined, startedAt: number, now: number): boolean {
  if (current && current !== baseline) return false
  return now - startedAt < POLL_LIMIT_MS
}
